import React from 'react';
import { StyleSheet } from 'react-native';
import { Text } from '../components/Texte';
import { colors, typography } from '../theme/tokens';
import type { MesureVoix } from '../hooks/useVoixRecruteur';

/**
 * INDICATEUR DE MESURE, HORS PRODUCTION SEULEMENT — affiché sous la bannière de l'entretien dans
 * les builds de développement et de preview, pour relever sur appareil le délai entre la fin du
 * texte et le début de la voix. `InterviewScreen` ne le monte jamais sur le canal production.
 * Texte interne à l'équipe : volontairement hors i18n.
 */
export function IndicateurVoix({ mesure }: { mesure: MesureVoix }) {
  const libelle =
    mesure.source === 'elevenlabs'
      ? `Voix ElevenLabs · ${mesure.delaiMs} ms`
      : `Voix du téléphone · ${mesure.raison ?? 'repli'}`;
  return (
    <Text testID="iv-indicateur-voix" style={styles.texte}>
      {libelle}
    </Text>
  );
}

const styles = StyleSheet.create({
  texte: { fontSize: typography.caption.size, color: colors.grey500, textAlign: 'center' },
});
